import { verifyPasswordResetToken } from "@vetty/api-sdk";
import { useSearchParams } from "react-router-dom";
import { createForm, setFieldValue } from "@/stores";
import { axiosInstance, withLocale } from "@/helpers";
import { useEffect } from "react";
import { useLocale } from "@/i18n";

/**
 * useResetPasswordToken Custom Hook
 *
 * Manages reset password token verification and form initialization.
 */
export const useResetPasswordToken = () => {
  const [searchParams] = useSearchParams();
  const locale = useLocale();

  useEffect(() => {
    createForm(["status", "token", "email", "password", "confirmPassword"]);
  }, []);

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get("token");

      if (!token) {
        window.location.href = withLocale(locale, "/login");
        return;
      }

      try {
        const { data } = await verifyPasswordResetToken(axiosInstance, token);

        if (!data.success) {
          window.location.href = withLocale(locale, "/login");
          return;
        }

        setFieldValue("email", data.email);
        setFieldValue("token", token);
      } catch (error) {
        console.error("Token verification error:", error);
        window.location.href = withLocale(locale, "/login");
      }
    };

    void verifyToken();
  }, [searchParams, locale]);
};
